import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {LayoutService} from "../service/layout.service";
import {SidenavService} from "../service/sidenav.service";
import {ThemeService} from "../service/theme.service";
import {MidiPlayerService} from "../service/midi-player.service";
import {HymnSelectionService} from "../service/hymn-selection.service";
import {SettingsService} from "../service/settings.service";
import {SinglePlayerComponent} from "./single-player/single-player.component";
import {TwoPlayerComponent} from "./two-player/two-player.component";
import {NgForOf, NgIf} from "@angular/common";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {translation} from "../translation";
import {MatSnackBar} from "@angular/material/snack-bar";
import {DoubleTapDirective} from "../directive/double-tap.directive";

@Component({
  selector: 'app-guess-the-hymn',
  standalone: true,
  imports: [
    SinglePlayerComponent,
    TwoPlayerComponent,
    NgIf,
    MatButtonModule,
    NgForOf,
    MatIconModule,
    DoubleTapDirective,
  ],
  templateUrl: './guess-the-hymn.component.html',
  styleUrl: './guess-the-hymn.component.scss'
})
export class GuessTheHymnComponent implements OnInit, AfterViewInit, OnDestroy {

  topScoreAllHymns = 0;
  topScoreFavoriteHymns = 0;

  singlePlayerActive = false;
  twoPlayerActive = false;

  allHymns = true;

  fullscreenBeforeGame = false;

  constructor(private layoutService: LayoutService, private sidenavService: SidenavService,
              private themeService: ThemeService, private midiPlayerService: MidiPlayerService,
              private hymnSelectionService: HymnSelectionService, private settingsService: SettingsService,
              private snackbar: MatSnackBar) {
    this.settingsService.loadSettings().then(() => {
        this.topScoreAllHymns = settingsService.getTopScoreAllHymns();
        this.topScoreFavoriteHymns = settingsService.getTopScoreFavoriteHymns();
        this.allHymns = settingsService.getGuessTheHymnAllHymnsEnabled();
      }
    );
  }

  ngAfterViewInit(): void {
  }

  ngOnInit(): void {
    if(this.layoutService.isNotBrowser()) {
      //this.layoutService.lockOrientation("portrait");
    }
  }

  ngOnDestroy() {
    this.exitGame();
    if(this.layoutService.isNotBrowser()) {
      this.layoutService.unlockOrientation();
    }
  }

  start1PlayerGame() {
    this.sidenavService.closeList();

    this.fullscreenBeforeGame = this.layoutService.fullscreen;

    this.singlePlayerActive = true;
    this.twoPlayerActive = false;

    //this.layoutService.lockOrientation("portrait");
  }

  start2PlayerGame() {
    this.sidenavService.closeList();

    // iOS fullscreen enter/exit doesn't look good, so just manipulate safe area for iOS
    if (this.layoutService.fullscreenSupported()) {
      this.fullscreenBeforeGame = this.layoutService.fullscreen;
      this.layoutService.enterFullScreen();
    }
    this.layoutService.noSafeArea();

    this.singlePlayerActive = false;
    this.twoPlayerActive = true;

    //this.layoutService.lockOrientation("portrait");
  }

  setAllHymns(allHymns: boolean) {
    if(!allHymns) {
      const favoriteCount = this.settingsService.getFavorites().length + this.settingsService.getHymnsToLearn().length;
      const favoritesNeeded = 10;
      if(favoriteCount < favoritesNeeded) {
        this.snackbar.open(translation.guess_the_hymn.add_more_favorites.replace("{x}", `${favoritesNeeded - favoriteCount}`), '', {
          duration: 4000,
        });
        return;
      }
    }
    this.allHymns = allHymns;
    this.settingsService.setGuessTheHymnAllHymnsEnabled(allHymns);
  }

  toggleMenu() {
    this.sidenavService.toggleList();
  }

  exitGame() {
    if(!this.layoutService.singleView) {
      this.sidenavService.openList();
    }

    // iOS fullscreen enter/exit doesn't look good, so just manipulate safe area for iOS
    if(this.layoutService.fullscreenSupported() && !this.fullscreenBeforeGame) {
      this.layoutService.exitFullScreen();
    }
    this.layoutService.initSafeArea();


    this.midiPlayerService.stop();
    this.singlePlayerActive = false;
    this.twoPlayerActive = false;
  }

  protected readonly translation = translation;

  onScore($event: number) {
    if(this.allHymns && $event > this.topScoreAllHymns) {
      this.topScoreAllHymns = $event;
      this.settingsService.setTopScoreAllHymns(this.topScoreAllHymns);
    } else if(!this.allHymns && $event > this.topScoreFavoriteHymns) {
      this.topScoreFavoriteHymns = $event;
      this.settingsService.setTopScoreFavoriteHymns(this.topScoreFavoriteHymns);
    }
  }

  async onDoubleTap() {
    if(this.layoutService.fullscreenSupported()) {
      await this.layoutService.toggleFullScreen();
    }
  }
}
